import React, { createContext, PropsWithChildren, useContext } from "react"

import { TranslationsService } from "./service"
import { TranslationsContext } from "./types"
import { useDefaultLanguageEffect } from "./useDefaultLanguageEffect"
import { useTranslationsChanger } from "./useTranslationsChanger"

const Context = createContext(new TranslationsContext())

export function TranslationsProvider({ children, service }: PropsWithChildren<{ service: TranslationsService }>) {
  const { getTranslations, persistLanguage, getDefaultLanguage } = service
  const { state, changeLanguage } = useTranslationsChanger({ getTranslations, persistLanguage })
  useDefaultLanguageEffect({ getDefaultLanguage, changeLanguage })

  return <Context.Provider value={{
    ...state,
    changeLanguage,
    i18n: (key) => {
      // console.debug("[i18n] svc-i18n", { key, state, App, Text: App?.Text })
      return service.translate({ key, translations: state.translations, language: state.language })
    },
  }}>
    {children}
  </Context.Provider>
}

export function useTranslations() {
  const context = useContext(Context)
  if (context === undefined) throw new Error("[useTranslations]")
  return context
}
